// Lang constants
export const UPDATE_LANG = 'UPDATE_LANG';

// samples constants
export const OPEN_SAMPLE = 'OPEN_SAMPLE';
export const OPEN_SAMPLE_FORM = 'OPEN_SAMPLE_FORM';
export const UPDATE_SAMPLE = 'UPDATE_SAMPLE';

// page constants

export const UPDATE_PAGE = "UPDATE_PAGE";
export const OPEN_MOBILE_MENU = "OPEN_MOBILE_MENU";

